/**
 * @desc 检查st是否过期
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(serviceTicket: string | number, options?: any) {
  return updateResponse(
    http(URL + `/serviceTicket/check/${serviceTicket}`, {
      method: "GET",

      ...options,
    }),
  );
}
